import React, { useState, useEffect } from "react";
import "./CookieBanner.css";
const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setShowBanner(false);
  };

  const handleReject = () => {
    localStorage.setItem("cookieConsent", "rejected");
    setShowBanner(false);
  };

  const handleCustomize = () => {
    // You can replace this with a real modal or settings page
    alert("Customize your cookie preferences here!");
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-banner">
      <h3>We respect your privacy</h3>
      <p>
        Cookies help us improve your experience, deliver personalized content, and analyze traffic. 
        You can choose which cookies to allow by clicking <strong>Customize</strong>. 
        Click <strong>Accept All</strong> to consent or <strong>Reject All</strong> to decline non-essential cookies.
      </p>
 
      <div className="cookie-buttons">
        <button className="accept-btn" onClick={handleAccept}>Accept All</button>
        <button className="reject-btn" onClick={handleReject}>Reject All</button>
        <button className="customize-btn" onClick={handleCustomize}>Customize</button>
      </div>
    </div>
  );
};

export default CookieBanner;
